module.exports = "../fonts/check_box_gray_checked.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/check_box_gray_checked.svg
// module id = 358
// module chunks = 0